import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeGroundItems(packet, writer = new BinaryWriter(64)) {
    writer.u8(ServerOp.GroundItems).u16(packet.tiles.length);
    for (const tile of packet.tiles) {
        writer.u16(tile.x).u16(tile.y).u8(tile.z).u8(tile.items.length);
        for (const stack of tile.items) {
            writer.u16(stack.typeId).u16(stack.count);
        }
    }
    return writer;
}
export function decodeGroundItems(reader) {
    const tileCount = reader.u16();
    const tiles = new Array(tileCount);
    for (let i = 0; i < tileCount; i++) {
        const x = reader.u16();
        const y = reader.u16();
        const z = reader.u8();
        const stackCount = reader.u8();
        const items = new Array(stackCount);
        for (let j = 0; j < stackCount; j++) {
            items[j] = { typeId: reader.u16(), count: reader.u16() };
        }
        tiles[i] = { x, y, z, items };
    }
    return { tiles };
}
//# sourceMappingURL=ground.js.map